const services = [
  {
    title: "Enfoque en el cliente",
    text: "Nuestra aplicación bajatuseguro pone al alcance de todos, la compra de Seguros de (Cualquier Compañía Aseguradora); de una manera fácil, brindando servicios de atención, asesoría y acompañamiento, en caso de algún siniestro o duda de cualquier índole.",
  },
  {
    title: "Digitalización",
    text: "Democratizar los seguros, donde el poder lo tenga el consumidor, donde califique a las aseguradoras y no tengan que depender de ningún agente.",
  },
  {
    title: "Atención 24/7",
    text: "Nuestros usuarios cuentan con nuestros servicios 24 horas al día los 365 días del año.",
  },
  {
    title: "Brindar herramientas",
    text: "Compara con más de 20 aseguradoras y busca la mejor opción de acuerdo a tus necesidades.",
  },
];

export default services;
